/**
 * LeisureMod Commercial — Featured Gallery
 * Click a numbered list item, or use the up/down arrows, to switch the
 * active project. Auto-advances on a timer with a visible progress bar
 * on the active list item, pausing on hover/focus and after any manual
 * interaction resets the timer rather than fighting the visitor's choice.
 * Self-contained — does not touch any other section's markup or scripts.
 */
(function () {
	var AUTO_ADVANCE_MS = 5500;

	function initGallery(root) {
		var triggers = root.querySelectorAll("[data-gallery-trigger]");
		var orbImages = root.querySelectorAll("[data-orb-image]");
		var panels = root.querySelectorAll("[data-gallery-panel]");
		var prevBtn = root.querySelector("[data-gallery-prev]");
		var nextBtn = root.querySelector("[data-gallery-next]");

		if (!triggers.length) return;

		// Marks the section ready for the entrance-reveal CSS. Set only once
		// we've confirmed there's real content to reveal — never as a
		// default, so a script error above this line leaves content visible.
		root.classList.add("js-ready");

		var total = triggers.length;
		var current = 0;
		var timer = null;
		var paused = false;

		function setActive(index, opts) {
			opts = opts || {};
			index = ((index % total) + total) % total; // wrap both directions
			current = index;

			triggers.forEach(function (btn) {
				var isActive = Number(btn.getAttribute("data-index")) === index;
				btn.classList.toggle("is-active", isActive);
				btn.setAttribute("aria-selected", isActive ? "true" : "false");
				// Restart the CSS progress-bar animation on the newly active item
				var track = btn.querySelector("[data-progress]");
				if (track) {
					track.classList.remove("is-filling");
					if (isActive && !paused) {
						// Force reflow so the animation restarts from 0 every time
						void track.offsetWidth;
						track.style.setProperty("--progress-duration", AUTO_ADVANCE_MS + "ms");
						track.classList.add("is-filling");
					}
				}
			});
			orbImages.forEach(function (img) {
				img.classList.toggle("is-active", Number(img.getAttribute("data-index")) === index);
			});
			panels.forEach(function (panel) {
				panel.classList.toggle("is-active", Number(panel.getAttribute("data-index")) === index);
			});

			if (!opts.silent) restartTimer();
		}

		function advance() {
			setActive(current + 1);
		}

		function restartTimer() {
			if (timer) clearTimeout(timer);
			if (paused || total < 2) return;
			timer = setTimeout(advance, AUTO_ADVANCE_MS);
		}

		function stopTimer() {
			paused = true;
			if (timer) clearTimeout(timer);
			var activeTrack = root.querySelector(".is-active [data-progress]");
			if (activeTrack) activeTrack.classList.remove("is-filling");
		}

		function resumeTimer() {
			paused = false;
			setActive(current, { silent: false });
		}

		triggers.forEach(function (btn) {
			btn.addEventListener("click", function () {
				setActive(Number(btn.getAttribute("data-index")));
			});
		});

		if (prevBtn) {
			prevBtn.addEventListener("click", function () {
				setActive(current - 1);
			});
		}
		if (nextBtn) {
			nextBtn.addEventListener("click", function () {
				setActive(current + 1);
			});
		}

		// Pause on hover/focus anywhere in the section, resume on leave —
		// standard courtesy for auto-advancing content
		root.addEventListener("mouseenter", stopTimer);
		root.addEventListener("mouseleave", resumeTimer);
		root.addEventListener("focusin", stopTimer);
		root.addEventListener("focusout", function (e) {
			if (!root.contains(e.relatedTarget)) resumeTimer();
		});

		// Only run the auto-advance timer while the section is actually
		// visible on screen, so it doesn't burn cycles or surprise the
		// visitor by having jumped ahead off-screen. The same observer
		// also triggers the one-time entrance reveal below.
		var hasRevealed = false;
		if ("IntersectionObserver" in window) {
			var io = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							if (!hasRevealed) {
								hasRevealed = true;
								root.classList.add("is-revealed");
							}
							paused = false;
							restartTimer();
						} else {
							stopTimer();
						}
					});
				},
				{ threshold: 0.4 }
			);
			io.observe(root);
		} else {
			root.classList.add("is-revealed");
			restartTimer();
		}

		setActive(0, { silent: true });
	}

	function init() {
		document.querySelectorAll("[data-featured-gallery]").forEach(initGallery);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();